import React from 'react';
import PropTypes from 'prop-types';
import CardRow from '../QuotationHeaderCardRow';
import { Grid, Hidden, Divider } from '@mui/material';
import { LocalOffer, PlaylistAddCheck } from '@mui/icons-material';
import { Autocomplete, CollapseCard, TextField, Card, Button } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { emptyString, emptyArray } from 'constants/defaultValues';
import { QuotationLoadingTitleWrapper } from '../CascoStyles';
import LinearProgressWrapper from 'components/common/LinearProgressWrapper';

export const QuotationListLoadingComponent = ({ index }) => {
  const { t } = useTranslation();

  return (
    <Grid item xs={12} key={index}>
      <Card icon={LocalOffer}>
        <Grid container direction={'column'}>
          <QuotationLoadingTitleWrapper item>
            <LinearProgressWrapper />
          </QuotationLoadingTitleWrapper>
          <Grid item container xs={12}>
            <Grid item container xs={12} lg={5}>
              <CardRow label={t('Offer.Edit.Casco.Header.ConventionName')} value={<LinearProgressWrapper />} />
              <CardRow label={t('Offer.Edit.Casco.Header.Periodicity')} value={<LinearProgressWrapper />} />
              <CardRow label={t('Offer.Edit.Casco.Header.Period')} value={<LinearProgressWrapper />} />
              <CardRow label={t('Offer.Edit.Casco.Header.InsuranceAmount')} value={<LinearProgressWrapper />} />
              <CardRow label={t('Offer.Edit.Casco.Header.TotalInsuranceAmount')} value={<LinearProgressWrapper />} />
              <CardRow
                label={t('Offer.Edit.Casco.Header.DiscountAmountLabel')}
                value={<TextField id='Discount_Amount' fullWidth isNumeric disabled value={emptyString} />}
              />
              <CardRow
                label={t('Offer.Edit.Casco.Header.DiscountPercent')}
                value={<TextField id='Discount_Percent' fullWidth isNumeric disabled value={emptyString} />}
              />
              <CardRow
                label={t('Offer.Edit.Casco.Header.PartialDamageDeductibleAmount')}
                value={
                  <Autocomplete
                    id='Partial_Damage_Deductible'
                    fullWidth
                    isNumeric
                    disabled
                    simpleValue={true}
                    value={emptyString}
                    options={emptyArray}
                  />
                }
              />
              <CardRow
                label={t('Offer.Edit.Casco.Header.TotalDamageDeductiblePercent')}
                value={
                  <Autocomplete
                    id='Total_Damage_Deductible'
                    fullWidth
                    isNumeric
                    disabled
                    simpleValue={true}
                    value={emptyString}
                    options={emptyArray}
                  />
                }
              />
            </Grid>
            <Hidden only={['xs', 'sm', 'md']}>
              <Grid item container lg={1} justifyContent='center'>
                <Divider orientation={'vertical'} />
              </Grid>
            </Hidden>
            <Grid item container direction='column' justifyContent='space-between' xs={12} lg={6}>
              <Grid item>
                <CollapseCard icon={PlaylistAddCheck} title={t('Offer.Edit.Casco.Risks.Title')} sx={{ mb: 1 }} toggleOnHeaderClick />
                <CollapseCard icon={PlaylistAddCheck} title={t('Offer.Edit.Casco.Coefficients.Title')} toggleOnHeaderClick />
              </Grid>
              <Grid item container spacing={1} justifyContent={'flex-end'}>
                <Grid item xs={6} sm={5} md={4} lg={3}>
                  <Button fullWidth id={'Select_Convention_' + index} color='primary' disabled={true}>
                    {t('General.Select')}
                  </Button>
                </Grid>
                <Grid item xs={6} sm={5} md={4} lg={3}>
                  <Button fullWidth id={'Save_Convention_' + index} disabled={true} color='primary'>
                    {t('General.Save')}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
};

QuotationListLoadingComponent.propTypes = {
  index: PropTypes.number
};

export default QuotationListLoadingComponent;
